// Runs before the body is parsed, so the resolved mode is in place for the first paint.
import "src/public/view_mode";

import Rails from "@rails/ujs";
Rails.start();

// Javascript
import "src/public/load_stimulus_controllers";
